<script setup lang="ts">
import HeightExpand from '~/components/transitions/heightExpand.vue'
import LogoIcon from '~/components/ui/LogoIcon/LogoIcon.vue'
import VCard from '~/components/ui/VCard.vue'
import VText from '~/components/ui/VText.vue'

const showText = ref(false)
</script>

<template>
  <VCard padding="4" class="!tw-bg-green-200">
    <div class="tw-flex tw-flex-row tw-justify-between">
      <div id="verified-badge" class="tw-flex tw-w-9/12 tw-flex-col tw-pr-3">
        <VText html-tag="h4" cfg="sans/16/medium" class="tw-pb-2">
          {{ $t('influencer.profile.slug.verifiedBadge.title') }}
        </VText>
        <VText
          v-if="!showText"
          cfg="sans/14/medium"
          class="tw-cursor-pointer tw-text-green-700"
          aria-expanded="false"
          aria-controls="verified-badge"
          @click="showText = true"
        >
          {{ $t('common.learnMore') }}
        </VText>
        <HeightExpand v-if="showText" class="tw-flex tw-flex-col">
          <div>
            <VText html-tag="p" cfg="sans/14/normal" class="tw-pb-2">
              {{ $t('influencer.profile.slug.verifiedBadge.description') }}
            </VText>
            <VText
              cfg="sans/14/medium"
              class="tw-cursor-pointer tw-text-green-700"
              aria-expanded="true"
              aria-controls="verified-badge"
              @click="showText = false"
            >
              {{ $t('influencer.profile.slug.verifiedBadge.gotIt') }}
            </VText>
          </div>
        </HeightExpand>
      </div>
      <LogoIcon class="!tw-text-green-600" size-override="40px" />
    </div>
  </VCard>
</template>
